import {HttpModelConverter} from "../../../../../../../core/converter/httpModel.converter";
import {Injectable} from "@angular/core";
import {TreatmentJourneyModel} from "./treatmentJourney.model";
import {
    ConsultationSummaryConverter
} from "../../../../../../consultation/consultation/api/model/converter/consultationSummary.converter";
import {
    TreatmentJourneyDefinitionSummaryConverter
} from "../../../../definition/journey/api/entity/treatmentJourneyDefinitionSummary.converter";
import {TreatmentJourneyStepConverter} from "../../../step/api/entity/treatmentJourneyStep.converter";

@Injectable({
    providedIn: 'root'
})
export class TreatmentJourneyConverter extends HttpModelConverter<TreatmentJourneyModel> {

    constructor(private consultationSummaryConverter: ConsultationSummaryConverter,
                private definitionConverter: TreatmentJourneyDefinitionSummaryConverter,
                private stepConverter: TreatmentJourneyStepConverter) {
        super();
    }

    protected createInstance(): TreatmentJourneyModel {
        return new TreatmentJourneyModel();
    }

    protected enrichObject(result: TreatmentJourneyModel, src: TreatmentJourneyModel) {
        result.consultation = this.consultationSummaryConverter.convert(src.consultation);
        result.definition = this.definitionConverter.convert(src.definition);
        result.steps = this.stepConverter.convertFromArray(src.steps);
    }
}